import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function FieldCard({ label, body }: { label: string; body?: string | null }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{label}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="whitespace-pre-wrap text-sm leading-relaxed text-foreground/90">
          {body ?? '—'}
        </p>
      </CardContent>
    </Card>
  );
}
